import { render, staticRenderFns } from "./AtfWhatsIncluded.vue?vue&type=template&id=2b77243a&scoped=true&"
import script from "./AtfWhatsIncluded.vue?vue&type=script&lang=ts&"
export * from "./AtfWhatsIncluded.vue?vue&type=script&lang=ts&"
import style0 from "./AtfWhatsIncluded.vue?vue&type=style&index=0&id=2b77243a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b77243a",
  null
  
)

export default component.exports